<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
    <g class="a">
      <circle class="b" cx="24" cy="24" :r="small ? 16 : 24"/>
      <circle class="c" cx="24" cy="24" :r="small ? 15 : 23"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: "PipelineCircleOutlinedIcon",
  props: {
    small: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.a {
  fill: #fff;
  stroke: #8ea2a8;
  stroke-width: 2px;
}

.b {
  stroke: none;
}

.c {
  fill: none;
}
</style>
